(function (root, factory) {
  if (typeof define === 'function' && define.amd)
    define(['exports', './kotlin-kotlin-stdlib.js', './fixers-s2-s2-automate-s2-automate-dsl.js', './fixers-f2-f2-dsl-f2-dsl-cqrs.js', './kotlinx-serialization-kotlinx-serialization-core.js'], factory);
  else if (typeof exports === 'object')
    factory(module.exports, require('./kotlin-kotlin-stdlib.js'), require('./fixers-s2-s2-automate-s2-automate-dsl.js'), require('./fixers-f2-f2-dsl-f2-dsl-cqrs.js'), require('./kotlinx-serialization-kotlinx-serialization-core.js'));
  else {
    if (typeof this['kotlin-kotlin-stdlib'] === 'undefined') {
      throw new Error("Error loading module 'boislocal-platform-platform-infra-urlShortener-urlShortener-domain'. Its dependency 'kotlin-kotlin-stdlib' was not found. Please, check whether 'kotlin-kotlin-stdlib' is loaded prior to 'boislocal-platform-platform-infra-urlShortener-urlShortener-domain'.");
    }
    if (typeof this['fixers-s2-s2-automate-s2-automate-dsl'] === 'undefined') {
      throw new Error("Error loading module 'boislocal-platform-platform-infra-urlShortener-urlShortener-domain'. Its dependency 'fixers-s2-s2-automate-s2-automate-dsl' was not found. Please, check whether 'fixers-s2-s2-automate-s2-automate-dsl' is loaded prior to 'boislocal-platform-platform-infra-urlShortener-urlShortener-domain'.");
    }
    if (typeof this['fixers-f2-f2-dsl-f2-dsl-cqrs'] === 'undefined') {
      throw new Error("Error loading module 'boislocal-platform-platform-infra-urlShortener-urlShortener-domain'. Its dependency 'fixers-f2-f2-dsl-f2-dsl-cqrs' was not found. Please, check whether 'fixers-f2-f2-dsl-f2-dsl-cqrs' is loaded prior to 'boislocal-platform-platform-infra-urlShortener-urlShortener-domain'.");
    }
    if (typeof this['kotlinx-serialization-kotlinx-serialization-core'] === 'undefined') {
      throw new Error("Error loading module 'boislocal-platform-platform-infra-urlShortener-urlShortener-domain'. Its dependency 'kotlinx-serialization-kotlinx-serialization-core' was not found. Please, check whether 'kotlinx-serialization-kotlinx-serialization-core' is loaded prior to 'boislocal-platform-platform-infra-urlShortener-urlShortener-domain'.");
    }
    root['boislocal-platform-platform-infra-urlShortener-urlShortener-domain'] = factory(typeof this['boislocal-platform-platform-infra-urlShortener-urlShortener-domain'] === 'undefined' ? {} : this['boislocal-platform-platform-infra-urlShortener-urlShortener-domain'], this['kotlin-kotlin-stdlib'], this['fixers-s2-s2-automate-s2-automate-dsl'], this['fixers-f2-f2-dsl-f2-dsl-cqrs'], this['kotlinx-serialization-kotlinx-serialization-core']);
  }
}(this, function (_, kotlin_kotlin, kotlin_io_komune_s2_s2_automate_dsl, kotlin_io_komune_f2_f2_dsl_cqrs, kotlin_org_jetbrains_kotlinx_kotlinx_serialization_core) {
  'use strict';
  //region block: imports
  var imul = Math.imul;
  var protoOf = kotlin_kotlin.$_$.fa;
  var S2Command = kotlin_io_komune_s2_s2_automate_dsl.$_$.g;
  var interfaceMeta = kotlin_kotlin.$_$.k9;
  var setMetadataFor = kotlin_kotlin.$_$.ga;
  var VOID = kotlin_kotlin.$_$.g;
  var WithS2Id = kotlin_io_komune_s2_s2_automate_dsl.$_$.e;
  var Event = kotlin_io_komune_f2_f2_dsl_cqrs.$_$.d;
  var S2InitCommand = kotlin_io_komune_s2_s2_automate_dsl.$_$.h;
  var PluginGeneratedSerialDescriptor = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_core.$_$.z1;
  var StringSerializer_getInstance = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_core.$_$.r;
  var get_nullable = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_core.$_$.v;
  var UnknownFieldException_init_$Create$ = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_core.$_$.e;
  var THROW_CCE = kotlin_kotlin.$_$.kd;
  var typeParametersSerializers = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_core.$_$.u1;
  var GeneratedSerializer = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_core.$_$.v1;
  var objectMeta = kotlin_kotlin.$_$.ea;
  var throwMissingFieldException = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_core.$_$.e2;
  var Unit_instance = kotlin_kotlin.$_$.t4;
  var objectCreate = kotlin_kotlin.$_$.da;
  var getStringHashCode = kotlin_kotlin.$_$.i9;
  var defineProp = kotlin_kotlin.$_$.b9;
  var classMeta = kotlin_kotlin.$_$.z8;
  //endregion
  //region block: pre-declaration
  setMetadataFor(UrlShortenerDeleteCommandDTO, 'UrlShortenerDeleteCommandDTO', interfaceMeta, VOID, [S2Command]);
  setMetadataFor(UrlShortenerDeletedEventDTO, 'UrlShortenerDeletedEventDTO', interfaceMeta, VOID, [WithS2Id, Event]);
  setMetadataFor(UrlShortenerPushCommandDTO, 'UrlShortenerPushCommandDTO', interfaceMeta, VOID, [S2InitCommand]);
  setMetadataFor(UrlShortenerPushedEventDTO, 'UrlShortenerPushedEventDTO', interfaceMeta, VOID, [WithS2Id, Event]);
  setMetadataFor(ShortUrlQrcodeDTO, 'ShortUrlQrcodeDTO', interfaceMeta);
  setMetadataFor($serializer, '$serializer', objectMeta, VOID, [GeneratedSerializer]);
  setMetadataFor(ShortQrcodeUrl, 'ShortQrcodeUrl', classMeta, VOID, [ShortUrlQrcodeDTO], VOID, VOID, {0: $serializer_getInstance});
  //endregion
  function UrlShortenerDeleteCommandDTO() {
  }
  function UrlShortenerDeletedEventDTO() {
  }
  function UrlShortenerPushCommandDTO() {
  }
  function UrlShortenerPushedEventDTO() {
  }
  function ShortUrlQrcodeDTO() {
  }
  function $serializer() {
    $serializer_instance = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('ShortQrcodeUrl', this, 5);
    tmp0_serialDesc.ht('id', false);
    tmp0_serialDesc.ht('name', false);
    tmp0_serialDesc.ht('qrcode', false);
    tmp0_serialDesc.ht('shortenUrl', false);
    tmp0_serialDesc.ht('redirectUrl', false);
    this.n2c_1 = tmp0_serialDesc;
  }
  protoOf($serializer).ii = function () {
    return this.n2c_1;
  };
  protoOf($serializer).wt = function () {
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [StringSerializer_getInstance(), get_nullable(StringSerializer_getInstance()), StringSerializer_getInstance(), StringSerializer_getInstance(), StringSerializer_getInstance()];
  };
  protoOf($serializer).ki = function (decoder) {
    var tmp0_desc = this.n2c_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = null;
    var tmp5_local1 = null;
    var tmp6_local2 = null;
    var tmp7_local3 = null;
    var tmp8_local4 = null;
    var tmp9_input = decoder.ul(tmp0_desc);
    if (tmp9_input.km()) {
      tmp4_local0 = tmp9_input.em(tmp0_desc, 0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
      tmp5_local1 = tmp9_input.im(tmp0_desc, 1, StringSerializer_getInstance(), tmp5_local1);
      tmp3_bitMask0 = tmp3_bitMask0 | 2;
      tmp6_local2 = tmp9_input.em(tmp0_desc, 2);
      tmp3_bitMask0 = tmp3_bitMask0 | 4;
      tmp7_local3 = tmp9_input.em(tmp0_desc, 3);
      tmp3_bitMask0 = tmp3_bitMask0 | 8;
      tmp8_local4 = tmp9_input.em(tmp0_desc, 4);
      tmp3_bitMask0 = tmp3_bitMask0 | 16;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp9_input.lm(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp9_input.em(tmp0_desc, 0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          case 1:
            tmp5_local1 = tmp9_input.im(tmp0_desc, 1, StringSerializer_getInstance(), tmp5_local1);
            tmp3_bitMask0 = tmp3_bitMask0 | 2;
            break;
          case 2:
            tmp6_local2 = tmp9_input.em(tmp0_desc, 2);
            tmp3_bitMask0 = tmp3_bitMask0 | 4;
            break;
          case 3:
            tmp7_local3 = tmp9_input.em(tmp0_desc, 3);
            tmp3_bitMask0 = tmp3_bitMask0 | 8;
            break;
          case 4:
            tmp8_local4 = tmp9_input.em(tmp0_desc, 4);
            tmp3_bitMask0 = tmp3_bitMask0 | 16;
            break;
          default:
            throw UnknownFieldException_init_$Create$(tmp2_index);
        }
      }
    tmp9_input.vl(tmp0_desc);
    return ShortQrcodeUrl_init_$Create$(tmp3_bitMask0, tmp4_local0, tmp5_local1, tmp6_local2, tmp7_local3, tmp8_local4, null);
  };
  protoOf($serializer).o2c = function (encoder, value) {
    var tmp0_desc = this.n2c_1;
    var tmp1_output = encoder.ul(tmp0_desc);
    tmp1_output.jn(tmp0_desc, 0, value.p2c_1);
    tmp1_output.nn(tmp0_desc, 1, StringSerializer_getInstance(), value.q2c_1);
    tmp1_output.jn(tmp0_desc, 2, value.r2c_1);
    tmp1_output.jn(tmp0_desc, 3, value.s2c_1);
    tmp1_output.jn(tmp0_desc, 4, value.t2c_1);
    tmp1_output.vl(tmp0_desc);
  };
  protoOf($serializer).ji = function (encoder, value) {
    return this.o2c(encoder, value instanceof ShortQrcodeUrl ? value : THROW_CCE());
  };
  var $serializer_instance;
  function $serializer_getInstance() {
    if ($serializer_instance == null)
      new $serializer();
    return $serializer_instance;
  }
  function ShortQrcodeUrl_init_$Init$(seen1, id, name, qrcode, shortenUrl, redirectUrl, serializationConstructorMarker, $this) {
    if (!(31 === (31 & seen1))) {
      throwMissingFieldException(seen1, 31, $serializer_getInstance().n2c_1);
    }
    $this.p2c_1 = id;
    $this.q2c_1 = name;
    $this.r2c_1 = qrcode;
    $this.s2c_1 = shortenUrl;
    $this.t2c_1 = redirectUrl;
    return $this;
  }
  function ShortQrcodeUrl_init_$Create$(seen1, id, name, qrcode, shortenUrl, redirectUrl, serializationConstructorMarker) {
    return ShortQrcodeUrl_init_$Init$(seen1, id, name, qrcode, shortenUrl, redirectUrl, serializationConstructorMarker, objectCreate(protoOf(ShortQrcodeUrl)));
  }
  function ShortQrcodeUrl() {
  }
  protoOf(ShortQrcodeUrl).k1y = function () {
    return this.p2c_1;
  };
  protoOf(ShortQrcodeUrl).h9 = function () {
    return this.q2c_1;
  };
  protoOf(ShortQrcodeUrl).l2c = function () {
    return this.r2c_1;
  };
  protoOf(ShortQrcodeUrl).m2c = function () {
    return this.s2c_1;
  };
  protoOf(ShortQrcodeUrl).k2c = function () {
    return this.t2c_1;
  };
  protoOf(ShortQrcodeUrl).toString = function () {
    return 'ShortQrcodeUrl(id=' + this.p2c_1 + ', name=' + this.q2c_1 + ', qrcode=' + this.r2c_1 + ', shortenUrl=' + this.s2c_1 + ', redirectUrl=' + this.t2c_1 + ')';
  };
  protoOf(ShortQrcodeUrl).hashCode = function () {
    var result = getStringHashCode(this.p2c_1);
    result = imul(result, 31) + (this.q2c_1 == null ? 0 : getStringHashCode(this.q2c_1)) | 0;
    result = imul(result, 31) + getStringHashCode(this.r2c_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.s2c_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.t2c_1) | 0;
    return result;
  };
  protoOf(ShortQrcodeUrl).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof ShortQrcodeUrl))
      return false;
    var tmp0_other_with_cast = other instanceof ShortQrcodeUrl ? other : THROW_CCE();
    if (!(this.p2c_1 === tmp0_other_with_cast.p2c_1))
      return false;
    if (!(this.q2c_1 == tmp0_other_with_cast.q2c_1))
      return false;
    if (!(this.r2c_1 === tmp0_other_with_cast.r2c_1))
      return false;
    if (!(this.s2c_1 === tmp0_other_with_cast.s2c_1))
      return false;
    if (!(this.t2c_1 === tmp0_other_with_cast.t2c_1))
      return false;
    return true;
  };
  //region block: post-declaration
  protoOf($serializer).xt = typeParametersSerializers;
  defineProp(protoOf(ShortQrcodeUrl), 'id', function () {
    return this.k1y();
  });
  defineProp(protoOf(ShortQrcodeUrl), 'name', function () {
    return this.h9();
  });
  defineProp(protoOf(ShortQrcodeUrl), 'qrcode', function () {
    return this.l2c();
  });
  defineProp(protoOf(ShortQrcodeUrl), 'shortenUrl', function () {
    return this.m2c();
  });
  defineProp(protoOf(ShortQrcodeUrl), 'redirectUrl', function () {
    return this.k2c();
  });
  //endregion
  //region block: exports
  function $jsExportAll$(_) {
    var $org = _.org || (_.org = {});
    var $org$boislocal = $org.boislocal || ($org.boislocal = {});
    var $org$boislocal$platform = $org$boislocal.platform || ($org$boislocal.platform = {});
    var $org$boislocal$platform$s2 = $org$boislocal$platform.s2 || ($org$boislocal$platform.s2 = {});
    var $org$boislocal$platform$s2$urlShortener = $org$boislocal$platform$s2.urlShortener || ($org$boislocal$platform$s2.urlShortener = {});
    var $org$boislocal$platform$s2$urlShortener$domain = $org$boislocal$platform$s2$urlShortener.domain || ($org$boislocal$platform$s2$urlShortener.domain = {});
    var $org$boislocal$platform$s2$urlShortener$domain$command = $org$boislocal$platform$s2$urlShortener$domain.command || ($org$boislocal$platform$s2$urlShortener$domain.command = {});
    var $org = _.org || (_.org = {});
    var $org$boislocal = $org.boislocal || ($org.boislocal = {});
    var $org$boislocal$platform = $org$boislocal.platform || ($org$boislocal.platform = {});
    var $org$boislocal$platform$s2 = $org$boislocal$platform.s2 || ($org$boislocal$platform.s2 = {});
    var $org$boislocal$platform$s2$urlShortener = $org$boislocal$platform$s2.urlShortener || ($org$boislocal$platform$s2.urlShortener = {});
    var $org$boislocal$platform$s2$urlShortener$domain = $org$boislocal$platform$s2$urlShortener.domain || ($org$boislocal$platform$s2$urlShortener.domain = {});
    var $org$boislocal$platform$s2$urlShortener$domain$command = $org$boislocal$platform$s2$urlShortener$domain.command || ($org$boislocal$platform$s2$urlShortener$domain.command = {});
    var $org = _.org || (_.org = {});
    var $org$boislocal = $org.boislocal || ($org.boislocal = {});
    var $org$boislocal$platform = $org$boislocal.platform || ($org$boislocal.platform = {});
    var $org$boislocal$platform$s2 = $org$boislocal$platform.s2 || ($org$boislocal$platform.s2 = {});
    var $org$boislocal$platform$s2$urlShortener = $org$boislocal$platform$s2.urlShortener || ($org$boislocal$platform$s2.urlShortener = {});
    var $org$boislocal$platform$s2$urlShortener$domain = $org$boislocal$platform$s2$urlShortener.domain || ($org$boislocal$platform$s2$urlShortener.domain = {});
    var $org$boislocal$platform$s2$urlShortener$domain$model = $org$boislocal$platform$s2$urlShortener$domain.model || ($org$boislocal$platform$s2$urlShortener$domain.model = {});
  }
  $jsExportAll$(_);
  _.$jsExportAll$ = $jsExportAll$;
  _.$_$ = _.$_$ || {};
  _.$_$.a = $serializer_getInstance;
  //endregion
  return _;
}));

//# sourceMappingURL=boislocal-platform-platform-infra-urlShortener-urlShortener-domain.js.map
